import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  QuoteText,
  Pivot,
  PicHolder,
  TopQ,
  BottomQ,
  TitleHolder,
  Title,
  SubTitle
} from "./VisionariesSlide4.style"

import TopQIcon from "./top_quote.svg"
import BottomQIcon from "./bottom_quote.svg"

export default function VisionariesSlide4() {
  return (
    <Holder>
      <Pivot>
        <PicHolder>
          <Pic src="/assets/images/about/architects/3.jpg" />
          <TitleHolder>
            <Title>Tri Landscape Design</Title>
            <SubTitle>Landscape Designers</SubTitle>
          </TitleHolder>
          <Overlay>
            <Caption>
              <TopQ src={TopQIcon} alt="" />
              <QuoteText>
                Tri has a passion for
                <br />
                design and enjoys getting
                <br />
                involved in the early phases
                <br />
                of the design process.
              </QuoteText>
              <BottomQ src={BottomQIcon} alt="" />
              <Text>
                Founded in 2017 Tri External Landscape Design is based in the Welsh Marches. The
                team of dedicated professionals combine individual abilities and experiences to
                deliver innovative and successful design solutions for clients, communicating those
                ideas with beautiful hand drawing and graphics.
              </Text>
              <Text>
                A successful design will respond to each unique site and its qualities. It will
                reflect its grain and historical context, its landform and natural resources to
                develop a concept that meets the project brief.
              </Text>
              <Text>
                Their highly experienced team has successfully delivered a wide range of projects
                including; large-scale residential developments, urban public realm, masterplans,
                large infrastructure projects and domestic gardens. We understand what it takes to
                conceive, develop and deliver a scheme.
              </Text>
            </Caption>
          </Overlay>
        </PicHolder>
      </Pivot>
    </Holder>
  )
}
